<template>
    <b-card class="col-md-3 mb-2 memberResult" :data-name="member.forename + ' ' + member.surname" :data-number="member.member_number">
        <b-card-title title-tag="h5" :title="member.forename.toUpperCase() + ' ' + member.surname.toUpperCase()"></b-card-title>
        <div class="layers bd bgc-white p-20">

            <div class="layer w-100 mB-10">
                <div class="peer">DOB (age)</div>
                <div class="peer peer-greed">

                    <h6>{{ dob }}</h6>
                </div>
            </div>

            <div class="layer w-100 mB-10">
                <div class="peer">Waivers</div>
                <div class="peer peer-greed">
                    <template v-for="site of sites">
                        <template v-if="mostRecentWaiver(site.id)">
                            <b-badge :key="site.id" variant="success" pill>{{ site.title }}</b-badge>
                        </template>
                        <template v-else>
                            <b-badge :key="site.id" variant="danger" pill>{{ site.title }}</b-badge>
                        </template>
                    </template>
                </div>
            </div>

            <div class="layer w-100 mB-10">
                <div class="peer">Membership Level</div>
                <div class="peer peer-greed">
                    <h6>{{ this.member.member_level.title }}</h6>
                </div>
            </div>

            <div v-if="member.member_number" class="layer w-100 mB-10">
                <div class="peer">Membership Number</div>
                <div class="peer peer-greed">
                    <h6>
                        {{ member.member_number }}
                    </h6>
                </div>
            </div>

            <div v-if="membershipExpiry" class="layer w-100 mB-10">
                <div class="peer">Membership Expiry</div>
                <div class="peer peer-greed">
                    <h6>{{ membershipExpiry }}</h6>
                </div>
            </div>

            <div class="layer w-100 mB-10">
                <div class="peer">Player Status</div>
                <div class="peer peer-greed">
                    <button v-if="!member.blocked && !member.warning && !member.banned" type="button" class="btn btn-block btn-success" disabled>Good</button>
                    <button v-if="member.blocked && !member.warning && !member.banned" type="button" class="btn btn-block btn-secondary" disabled>Blocked</button>
                    <button v-if="!member.blocked && member.warning && !member.banned" type="button" class="btn btn-block btn-warning" disabled>Warning</button>
                    <button v-if="!member.blocked && !member.warning && member.banned" type="button" class="btn btn-block btn-danger" disabled>Banned</button>
                    <button v-if="!member.blocked && member.warning && member.banned" type="button" class="btn btn-block btn-danger" disabled>Banned</button>
                </div>
            </div>

            <div class="layer w-100 mB-10">
                <div class="peer">Alerts</div>
                <div class="peer peer-greed">
                    <button v-if="member.notes && member.notes.length" class="btn btn-outline-secondary btn-block" disabled type="button" :title="member.notes[0].note">
                        <i class="fa fa-pencil-square-o"></i> Notes
                    </button>
                    <button v-if="member.ice_notes" class="btn btn-outline-danger btn-block" disabled type="button">
                        <i class="fa fa-heartbeat"></i> Medical
                    </button>

                    <template v-if="!member.notes.length && !member.ice_notes">N/A</template>
                </div>
            </div>

            <div class="layer w-100 mB-10">
                <div class="peer">Actions</div>
                <div class="peer peer-greed">
                    <!-- <a :href="'/member/' + member.id" class="btn btn-block btn-secondary">View</a> -->
                    <a :href="$routes.route('member.show', {member: member.id})" class="btn btn-block btn-secondary">View</a>
                    <button type="button" class="btn btn-block btn-danger" @click="deleteShow=true">Delete</button>
                </div>
            </div>
        </div>
        <b-modal v-model="deleteShow" hide-footer title="Delete Memeber">
            <p class="mt-2 mb-0">Are you sure you want to delete {{ member.forename.toUpperCase() }} {{ member.surname.toUpperCase() }}?</p>
            <p class="mb-4 mt-0">This can not be undone</p>
            <b-button class="mt-3" variant="outline-danger" block @click="deleteMember()">Confirm</b-button>
            <b-button class="mt-2" variant="outline-secondary" block @click="deleteShow=false">Cancel</b-button>
        </b-modal>
    </b-card>
</template>

<script>
export default {
    props: {
        member: {
            default: false
        }
    },
    data() {
        return {
            deleteShow: false,
            memberData: false,
            sites: Sites,
            now: new moment(),
            dob: "Unknown",
            membershipExpiry: false,
        };
    },
    methods: {
        deleteMember() {
            axios.delete(this.$routes.route("member.destroy", { member: this.member.id }))
                .then((result) => {
                    this.$emit("member-deleted");
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        mostRecentWaiver(location) {
            var waivers = this.member.waivers.filter(waiver => {
                var exp = new moment(waiver.expiry);
                return waiver.site.id == location && exp > this.now;
            });

            return waivers.length;
        }
    },
    mounted() {
        if (this.member.dob) {
            var diff = this.now.diff(moment(this.member.dob), "years");
            this.dob = new moment(this.member.dob).format("DD/MM/YYYY") + " (" + diff + ")";
        } else {
            this.dob = "Unknown";
        }

        if (this.member.member_expiry) {
            var exp = moment(this.member.member_expiry);
            var leftDiff = exp.diff(this.now, "days");

            if (leftDiff > 0) {
                this.membershipExpiry = exp.format("DD/MM/YYYY") + " (" + leftDiff + " Days Left)";
            } else {
                this.membershipExpiry = exp.format("DD/MM/YYYY") + " (EXPIRED)";
            }
        } else {
            this.membershipExpiry = "N/A";
        }
    }
};
</script>